// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"ec8fb487","488":"dd8b2d40","663":"3bb0eaf4"}[chunkId] + ".chunk.js";
};